import '../scss/main.scss';
import $ from 'jquery';
import navigation from './global/navigation';
import blockAnchorLinksBar from './blocks/block-anchor-links-bar';
import blockSocialLink from '@/js/blocks/block-social-links';
import blockReferences from '@/js/blocks/block-references';
import blockContentAndAccordion from '@/js/blocks/block-content-and-accordion.js';
import blockCarousel from '@/js/blocks/block-carousel';
import blockFreshCycle from '@/js/blocks/block-fresh-cycle';
import blockReproductive from '@/js/blocks/block-reproductive';
import blockTitleTile from '@/js/blocks/block-title-tile';
import blockVideo from './blocks/block-video';
import blockQuestionPath from './blocks/block-question-path';
import blockShare from './blocks/block-share';
import resourceList from './blocks/block-resource-list';

$(function () {
  navigation();
  blockAnchorLinksBar();
  blockSocialLink();
  blockReferences();
  blockContentAndAccordion();
  blockCarousel();
  blockFreshCycle();
  blockReproductive();
  blockTitleTile();
  blockVideo();
  blockQuestionPath();
  blockShare();
  resourceList();
});
